import { PaginationParams, PaginationResponse } from 'models/pagination'
import { User, UserDTO } from 'models/user'

import { clientApi } from './clientApi'

export interface UsersResetPasswordData {
  password: string
}

export const UsersApi = {
  getMe() {
    return clientApi.get('/web/users/me/')
  },
  getUsers(params: PaginationParams) {
    return clientApi.get<PaginationResponse<User>>('/web/users/', {
      params,
    })
  },
  signUp(data: Partial<UserDTO>) {
    return clientApi.post<User>('/web/users/sign_up/', data).catch(err => {
      throw err.response.data
    })
  },
  updateUser(data: Partial<UserDTO>) {
    return clientApi.put<User>(`/web/users/${data.phone}/`, data).catch(err => {
      throw err.response.data
    })
  },
  patchUser(phone: string, data: FormData) {
    return clientApi.patch<User>(`/web/users/${phone}/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  deleteUser(phone: string, block_reason: string) {
    return clientApi.delete(`/web/users/${phone}/`, {
      data: {
        block_reason,
      },
    })
  },

  resetPassword(phone: string, data: UsersResetPasswordData) {
    return clientApi.post(`/web/users/${phone}/reset_password/`, data)
  },

  approveRegistration(phone: string) {
    const url = `/web/users/${phone}/approve_registration/`

    return clientApi.post(url)
  },
}
